/**
 * String truncation utilities.
 *
 * Pure functions — no side effects.
 */

/**
 * Truncate a string with an ellipsis. Returns `fallback` for null/undefined/empty.
 */
export function truncate(
  s: string | undefined | null,
  maxLen: number,
  options?: { fallback?: string },
): string {
  if (!s) return options?.fallback ?? '—';
  return s.length > maxLen ? s.slice(0, maxLen) + '…' : s;
}
